<template lang="pug">
#account-select
    v-autocomplete.account-selector(
        v-model="select",
        solo,
        dense,
        :multiple="multiple",
        :hide-details="hideDetails",
        :rules="rules",
        outlined,
        clearable,
        item-text="name",
        item-value="id",
        :items="accounts",
        :placeholder="$t('Placeholder.__Account')",
        @click:clear="clearAction"
        :return-object="returnObject"
    )
        //- template(v-slot:selection="data")
        //-     | {{data.name}}

        template(v-slot:item="data")
            template(v-if="!isObjectType(data.item)")
                v-list-item-content(v-text="data.item")
            template(v-else)
                v-list-item-content {{ data.item.name }}

        template(v-slot:append-item v-if="insertTag")
            v-divider
            v-list-item.text-left(@click="addAccountDialog=true")
                v-list-item-avatar
                    v-icon add
                v-list-item-content
                    v-list-item-title {{$t("Products.__AddNewAccount")}}

    EditAccountDialog(
        v-model="addAccountDialog",
        :edit-type="1",
        :confirm-action="insertDoneAction",
        :account-category-groups="accountCategoryGroups"
    )
</template>
<script>
import * as accountHelper from "@/utils/accountHelper"
import EditAccountDialog from "@/components/accounting/EditAccountDialog"

export default {
  mixins: [accountHelper.mixin],
  components: { EditAccountDialog },

  props: {
    value: {
      type: [Object, String],
      default: null
    },
    allEnabled: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    insertTag: {
      type: Boolean,
      default: false
    },
    archivedTag: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    groupKey: {
      type: String,
      default: null
    },
    groupKeys: {
      type: Array,
      default: () => {
        return []
      }
    },
    categoryKeys: {
      type: Array,
      default: () => {
        return []
      }
    },
    excludeCategories: {
      type: Array,
      default: () => {
        return []
      }
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      search: null,
      addAccountDialog: false,
      items: [],
      select: null,
      nowTime: Date.now(),
      accounts: [],
      accountCategoryGroups: null,
      accountsRaw: [
        {
          key: "Assets",
          categories: [
            {
              key: "CashAndCashEquivalents",
              accounts: [
                {
                  id: "74a5e98",
                  group: "Assets",
                  category: "CashAndCashEquivalents",
                  name: "Cash on Hand",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "e0a72f8",
                  group: "Assets",
                  category: "CashAndCashEquivalents",
                  name: "Cash in Banks",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "a3eb122",
                  group: "Assets",
                  category: "CashAndCashEquivalents",
                  name: "Deposit Account",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "8694d53",
                  group: "Assets",
                  category: "CashAndCashEquivalents",
                  name: "Cash in Transit",
                  description: null,
                  isArchived: false,
                  isEditable: true
                }
              ]
            },
            {
              key: "AccountsReceivable",
              accounts: [
                {
                  id: "fa72d69",
                  group: "Assets",
                  category: "AccountsReceivable",
                  name: "Notes Receivable",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "06d4184",
                  group: "Assets",
                  category: "AccountsReceivable",
                  name: "Accounts Receivable",
                  description: null,
                  isArchived: false,
                  isEditable: true
                }
              ]
            },
            {
              key: "Inventories",
              accounts: [
                {
                  id: "215fbcd",
                  group: "Assets",
                  category: "Inventories",
                  name: "Merchandise Inventory",
                  description: null,
                  isArchived: false,
                  isEditable: true
                }
              ]
            }
          ]
        },
        {
          key: "Liabilities",
          categories: [
            {
              key: "CurrentLiabilities",
              accounts: [
                {
                  id: "cce48b2",
                  group: "Liabilities",
                  category: "CurrentLiabilities",
                  name: "Short-Term Debt",
                  description: null,
                  isArchived: false,
                  isEditable: true
                }
              ]
            },
            {
              key: "AccountsPayable",
              accounts: [
                {
                  id: "407ff0f",
                  group: "Liabilities",
                  category: "AccountsPayable",
                  name: "Accounts Payable",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "0282954",
                  group: "Liabilities",
                  category: "AccountsPayable",
                  name: "Notes Payable",
                  description: null,
                  isArchived: false,
                  isEditable: true
                }
              ]
            },
            {
              key: "LongTermLiabilities",
              accounts: [
                {
                  id: "9593a8c",
                  group: "Liabilities",
                  category: "LongTermLiabilities",
                  name: "Long-Term Debt Payable",
                  description: null,
                  isArchived: false,
                  isEditable: true
                }
              ]
            }
          ]
        },
        {
          key: "OperatingCosts",
          categories: [
            {
              key: "Purchases",
              accounts: [
                {
                  id: "38a1b06",
                  group: "OperatingCosts",
                  category: "Purchases",
                  name: "Purchases",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "dc7a819",
                  group: "OperatingCosts",
                  category: "Purchases",
                  name: "Purchase Expenses",
                  description: null,
                  isArchived: false,
                  isEditable: true
                }
              ]
            }
          ]
        },
        {
          key: "OperatingExpenses",
          categories: [
            {
              key: "Expenses",
              accounts: [
                {
                  id: "86ca7d0",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Payroll Expense",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "928763e",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Rent Expense",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "73934cd",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Supplies Expense",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "aeb9d1a",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Travelling Expense",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "888040f",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Shipping Expense",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "808c76d",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Postage Expense",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "97a8ffa",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Repairs and Maintenance",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "579f542",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Advertisement Expense",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "e2a2376",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Utilities Expense",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "7875847",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Insurance Expense",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "1261e06",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Entertainment Expense",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "d0002f1",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Donation Expense",
                  description: null,
                  isArchived: false,
                  isEditable: true
                },
                {
                  id: "682a697",
                  group: "OperatingExpenses",
                  category: "Expenses",
                  name: "Taxes",
                  description: null,
                  isArchived: false,
                  isEditable: true
                }
              ]
            }
          ]
        }
      ],
      groupSortPriority: {
        Assets: 1,
        Liabilities: 2,
        Income: 3,
        OperatingExpenses: 4,
        OperatingCosts: 5,
        OwnersEquity: 6
      }
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
    value(val) {
      this.select = val
    },
    select(val) {
      if (val) {
        this.$emit("input", val)
      }
    }
  },
  methods: {
    clearAction() {
      this.$emit("input", null)
    },
    getAccountsByGroup(groupKey, accountId) {
      this.$store
        .dispatch("accounting/getAccountsByGroup", groupKey)
        .then(
          function(response) {
            var groupAccounts = []
            // groupAccounts.push({ header: this.$t("__" + groupKey) })
            response.data.map(account => {
              if (!account.isArchived || this.archivedTag) {
                account.name = this.getAccountTranslatedName(account.name)
                groupAccounts.push(account)
              }
            })
            this.accounts = groupAccounts
            if (accountId) {
              this.select = accountId
            }
          }.bind(this)
        )
        .catch(function(error) {}.bind(this))
    },
    getAllAccounts(accountId) {
      var accountings = this.$store.getters["accounting/accountings"]
      if (accountings.length == 0) {
        this.getAllAccountsByAPI()
      } else {
        this.handleRawAccountsData(accountings, accountId)
      }
    },
    getAllAccountsByAPI() {
      this.$store
        .dispatch("accounting/getAccounts")
        .then(
          function(response) {
            this.handleRawAccountsData(response.data.groups)
          }.bind(this)
        )
        .catch(function(error) {}.bind(this))
    },
    handleRawAccountsData(rawData, accountId) {
      // sorting
      rawData.sort(
        function(a, b) {
          return this.groupSortPriority[a.key] - this.groupSortPriority[b.key]
        }.bind(this)
      )
      var accounts = []
      if (this.allEnabled) {
        accounts.push({
          name: this.$t("Reports.__AllAccounts"),
          id: "all_accounts"
        })
      }
      var groupKeys = this.groupKeys
      var categoryKeys = this.categoryKeys
      var excludeCategories = this.excludeCategories
      rawData.map(group => {
        if (groupKeys.length == 0 || groupKeys.includes(group.key)) {
          var groupAccounts = []
          groupAccounts.push({
            header: this.$t("AccountGroups.__" + group.key)
          })
          group.categories.map(category => {
            if (categoryKeys.length == 0 || categoryKeys.includes(category.key)) {
              if (!excludeCategories.includes(category.key)) {
                category.accounts.map(account => {
                  if (!account.isArchived || this.archivedTag) {
                    account.name = this.getAccountTranslatedName(account.name)
                    groupAccounts.push(account)
                  }
                })
              }
            }
          })
          groupAccounts.push({ divider: true })
          accounts = accounts.concat(groupAccounts)
        }
      })
      this.accounts = accounts
      if (accountId) {
        this.select = accountId
      }
    },
    insertDoneAction(accountId) {
      if (this.groupKey == null) {
        this.getAllAccounts(accountId)
      } else {
        this.getAccountsByGroup(this.groupKey, accountId)
      }
    },
    isObjectType(item) {
      return typeof item == "object"
    }
    // getAccountTranslatedName(name) {
    //     if (Object.keys(this.keyMapping).includes(name)) {
    //         return this.$t("Accounts." + this.keyMapping[name])
    //     } else {
    //         return name
    //     }
    // }
  },
  mounted() {
    if (this.groupKey == null) {
      this.getAllAccounts()
    } else {
      this.getAccountsByGroup(this.groupKey)
    }
    // this.handleRawAccountsData(this.accountsRaw)
    // this.select = this.value
    if (this.value != null) {
      this.select = this.value
    }
  },
  created() {
    this.accountCategoryGroups = [this.groupKey]
  }
}
</script>
